import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';
import { EquipmentAnswerCiteViewModel } from '../stores/questions.store';
import { Divider, Flex, Text } from '@servicetitan/anvil2';
import { MessageBubble } from '../../common/components/message-bubble/message-bubble';
import { DownloadDocument } from '../../common/components/download-document/download-document';
import { Markdown } from '../../common/components/entity-components/markdown/markdown';
import { EquipmentDocumentApiModel } from '../../common/api/equipments.api';

export interface EquipmentAnswerProps {
    answer: EquipmentAnswerCiteViewModel;
    onViewPdf: (document: EquipmentDocumentApiModel, page: number) => void;
}

export const EquipmentAnswer: FC<EquipmentAnswerProps> = observer(({ answer, onViewPdf }) => {
    const documents = answer.citations
        .filter(x => !!x.file)
        .map(x => ({ doc: x.file!, page: x.pageNumber }));
    return (
        <Flex direction="column" gap="2">
            <MessageBubble isMine={false}>
                <Flex direction="column" gap="3">
                    <Markdown text={answer.answer} />
                    {answer.citations.map((c, index) => {
                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Fragment key={index}>
                                <Divider />
                                <Text>
                                    {/* eslint-disable react/no-danger,@typescript-eslint/naming-convention */}
                                    <span dangerouslySetInnerHTML={{ __html: c.text ?? '' }} />
                                </Text>
                            </Fragment>
                        );
                    })}
                </Flex>
            </MessageBubble>
            {documents.length > 0 && (
                <Flex direction="column" gap="1">
                    <Text variant="eyebrow">source</Text>
                    <DownloadDocument documents={documents} onViewPdf={onViewPdf} />
                </Flex>
            )}
        </Flex>
    );
});
